export default __webpack_public_path__ + "static/media/agregar-producto-atributo.f7cd5c1f.svg";